import KendoTreeMap from './KendoTreeMap'
import KendoTreeMapInstaller from './kendo-treemap-installer'

export { KendoTreeMap, KendoTreeMap as TreeMap, KendoTreeMapInstaller, KendoTreeMapInstaller as TreeMapInstaller }


// WEBPACK FOOTER //
// ./packages/kendo-treemap-vue-wrapper/src/index.js